export default "__VITE_ASSET__VSeAb9f$__"